var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleOptimize = function SvgGoogleOptimize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f8cb11e1-d539-4567-8096-a9b3a44fbf7a",
    "data-name": "Layer 1",
    viewBox: "0 0 8103.6 2467.7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1576,1228.5c-4.3-186.9-158.2-335.6-345.2-333.4H340.7v666.7H917.2v560.7c-10,180.4,128.1,334.8,308.5,344.8,3.9.2,7.9.4,11.8.4,188.8-1.9,340.3-156.4,338.4-345.2h0v-894Z",
    transform: "translate(0 0)",
    style: {
      fill: "#b366f6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.8,
    cy: 1232.5,
    r: 336.8,
    style: {
      fill: "#8430ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2397.8,335.1C2396,149.5,2245,0,2059.4,0H1149C976,17.4,844.4,162.9,844.4,336.8S976,656.1,1149,673.5h583.2v560.1c-7.5,184,135.6,339.2,319.5,346.7s339.2-135.6,346.7-319.5c.4-9,.4-18.1,0-27.1Z",
    transform: "translate(0 0)",
    style: {
      fill: "#c58af8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3875.6,1103.6c-1.8,277.2-210.8,487-483.6,485.4s-480.6-216.6-478.3-492.2,213.2-487.7,484.8-486.1S3877.4,827.3,3875.6,1103.6Zm-114.1-2.1c.4-217.6-157.8-383.8-364.7-383.3-209.4.5-368.6,164.8-368.6,380.5s157.9,382.9,365.6,383.7S3761.1,1317.7,3761.5,1101.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5507.3,942.3l97.9.5c2.8,26.3,5.7,53,10.1,93.5,60.4-72,128.2-113.9,213-113.5,86.4.5,150.9,43.5,203.2,137.3,10.3-20.4,14.2-34.1,22.7-43.9,75.6-87.2,171.2-109.3,279-77.4,88.9,26.2,134.6,96.9,138.4,182,6.8,151.9.5,304.3-.3,460.5l-102.7-.6c-1-20.6-2.6-41.5-2.9-62.4-1.6-120.8-1.5-241.6-4.7-362.3-1.5-57-24.3-103.3-84.6-120.8s-118.6-10.3-165.7,36.7-64.5,103-65,166.6c-.8,112.4-1.3,224.8-1.9,340.8l-109.6-.5c-1-18.8-2.9-36.6-2.9-54.3-.1-119.2,1-238.5,0-357.7-.5-57.9-17-109.6-78.2-131.1-64.2-22.5-124.7-15.3-174.6,35.1-42.9,43.3-62.1,96.6-62.4,157.2-.4,115.6-1.2,231.1-1.8,349.7l-110.3-.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4010.7,934.4l98.1.5c2.1,26.5,4.2,53.3,6.7,84.2,9.2-4,16.6-5,20-9.1,110.1-136.6,342.5-130.9,456.5,51.3,94,150.1,58.5,367-81.6,475.1-110.8,85.5-269.5,73-366.2-28.6-6.7-7-14.3-13.2-29.4-26.9-1.7,21.1-3.8,34.2-3.6,47.4,1.2,87.7,3.5,175.4,4.2,263.2.5,63.7-.3,63.9-62.8,62.5-14.5-.4-29.1-2.3-46.8-3.7Zm305.9,556.1c123.2,1.9,215.9-97.7,217.3-233.6,1.5-133.7-88.1-237.7-206.4-239.6-123.6-2-215,96.9-216.4,234.1S4196.5,1488.7,4316.6,1490.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8103.6,1291.1l-499.9-2.6c-9.2,87.2,33,160.7,109.6,199.3,79.2,39.8,169.3,26.3,234.6-35.3,60.1-56.6,64-56.7,137.5-3.7-49.6,104.4-176.2,173.4-299.5,163.1-140-11.6-250.2-96.8-288-222.3-50-166.1,10.7-343.2,145.2-416.9,171.2-93.8,436.7-25.3,457.2,248.5C8101.7,1240.9,8102.2,1260.6,8103.6,1291.1ZM7612,1195.5l367.9,2c.5-90.3-70.8-157.3-167.8-161.4C7703.7,1031.5,7621.3,1095.3,7612,1195.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7262.7,1052.5l-359.7-1.9.5-99.8,494.2,2.6c5.9,47.9,11.3,91.7-28.5,135.2-102.9,112.7-201,229.7-300.8,345.2-11.4,13.1-21.5,27.3-38.4,49l366.4,2-.5,102.6-505.1-2.7c-8.5-54.1-5.6-99.7,36.4-144.9,100.5-108,194.8-221.8,291.4-333.5C7230.3,1092.9,7241.1,1078.9,7262.7,1052.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4697.8,1036.8l.5-100.8c19.7.1,37.7-2,54.9.7,50,7.7,65.2-15,60.2-61.3-2.7-24.5-.3-49.6-.1-74.5.6-63.5.7-61.7,63.7-62.4,34.3-.4,49.4,10.2,45.6,45.5-2.1,19.7-.7,39.7-.6,59.6.6,110.3-11.5,91.6,90.8,94,19.7.5,39.5.3,63.4.4l-.6,103.4c-38.1-.2-77.2.6-116.3-1-28-1.2-38.7,10.3-38.6,37.6.2,97.8-3.1,195.6-.3,293.3,2.5,89.6,42.9,119.7,132,106.1,2.7,1.9,6.4,3.4,7.6,6,40.9,90.7,32.9,102.9-67.1,103.9-104.4,1-178.4-66-181.1-169.7s-.3-208.7-.2-313.1c.1-64,0-63.9-65.9-65.1C4731,1039.2,4716.4,1037.9,4697.8,1036.8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5228.1,940.8l106.3.6-3.4,635-106.3-.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6747.6,1584.7l-105.8-.6,3.3-634.6,105.9.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5281.5,793.4c-43.4-1.2-77-36.6-76.6-80.7.4-45.9,39-83.3,82.8-80.2s75.3,38.9,73.8,83.8S5325.1,794.7,5281.5,793.4Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6777.6,718.6c.7,45.5-31.1,80.5-74.8,82.4s-82.2-34.6-81.9-80.4c.3-44,34.9-80,77.5-80.7S6776.9,674.9,6777.6,718.6Z",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7979.9,1197.5l-367.9-2",
    transform: "translate(0 0)",
    style: {
      fill: "#4f4f4f"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleOptimize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-optimize.7e116f42.svg";
export { ForwardRef as ReactComponent };